import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseFirewall from '../../AbstractObjects/GatewayPlan/InnerPages/BaseFirewall';

const pageSchema = PlanGetSchema.pages.firewall;
const pageId = pageSchema.pageId;

function PlanFirewall({
    planObject,
    setPlanData,
    setEditorPageId
}) {
    let pageData = planObject[pageId];

    return (
        <BaseFirewall
            pageData={pageData}
            setObjectData={setPlanData}
            setEditorPageId={setEditorPageId}
        />
    );
}

export default PlanFirewall;